import { isOneOf } from './isOneOf';

const msalAadOrMsaRedirectErrors = ['AadOrMsaRedirRequired'];

export function isMsalAadOrMsaRedirectError(message: string | undefined): boolean {
    return isOneOf(msalAadOrMsaRedirectErrors, message);
}
